import React, { useState } from 'react'
import './css/screen3.css';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { levels } from '../utils/levels';
import { PopupSub,Popup } from '../utils/constant';
import { useTranslation } from 'react-i18next';
import { getAllOpponent,getSubStatus,topup } from '../services/home';
const Screen3 = () => {

    const language = localStorage.getItem('selectedLanguage');
    const { t } = useTranslation();
    const location = useLocation();
    const [quiz, setQuiz] = useState(location?.state);
    const [subStatus, setSubStatus] = useState(0);
    const [popup, setPopup] = useState(false);
    const [popupLoader, setPopupLoader] = useState(false);
    const navigate = useNavigate();
    const [quizLevel, setQuizLevel] = useState(levels[0]);
    const handleQuizClick = (quizValue, quizLevelValue) => {
        setQuiz(quizValue);
        setQuizLevel(quizLevelValue);
    };

    const [loading,setLoading]=useState(false);

    const goBack = () => {
        navigate(-1);
    };

    const redirectTo = async (input) => {
       /* if(input==='/subscribe')
        {
            localStorage.removeItem("token");
            localStorage.setItem('subAgain',"1");
            window.location.href="/";
        }
        else
        {*/
            if(input && input.length>2)navigate(input);
            else {setSubStatus(0);setPopup(false);}
        //}
    }
     const handleTopup = async () => {
        setSubStatus(0);
        setPopup(false);
        setPopupLoader(true);
            await topup()
            .then((res) => { 
            setPopupLoader(false);
            if(res.responseCode===200){setSubStatus(200);setPopup(true);}
            else {setSubStatus(204);setPopup(true);}                
            }).catch((err) => {
            console.log(err);                
            setPopupLoader(false);
            if(err.message==="LOW BALANCE"){setSubStatus(205);setPopup(true);}
                else {setSubStatus(204);setPopup(true);}
            });
            
    }

     const handlePlay = async () => {
        try {
            setSubStatus(0);
            setLoading(true);
             await getSubStatus()
              .then((res) => { 
                setSubStatus(res.responseCode);//200 success,203 low balance,202 Charging in process
                if(res.responseCode===200)
                {
                    if(res.questions>=10)
                    {
                        const stateData = {qid: location?.state,lavel: quizLevel}                
                        navigate("/finding", { state: stateData });
                    }
                    else {setSubStatus(201);setPopup(true);}
                }
                else {setPopup(true);}
                setLoading(false);
              }).catch((err) => {
                console.log(err);
                setLoading(false);
              });
            

        } catch (error) {
            setLoading(false);
            console.error("handlePlay ", error);
        }
    }
    const handlePlaySolo = async () => {
        try {           
            setSubStatus(0);
            setLoading(true);
             await getSubStatus()
              .then((res) => { 
                setSubStatus(res.responseCode);//200 success,203 low balance,202 Charging in process
                if(res.responseCode==200)
                {
                    if(res.questions>=10)
                    {
                        getAllOpponent().then((resp) => {
                        setLoading(false);
                        const stateData={qid: location?.state,lavel: quizLevel,players: resp };
                        navigate("/play-solo", { state: stateData})
                        }).catch((err) => {
                            console.log(err);
                            setLoading(false);
                        });
                    }
                    else {setLoading(false);setSubStatus(201);setPopup(true);}
                }
                else {setLoading(false);setPopup(true);}
              }).catch((err) => {
                console.log(err);
                 setLoading(false);
              });

        } catch (error) {
            setLoading(false);
            console.error("Failed to fetch opponents", error);
        }
    };

    return (
        <div className='home level-page'>
            <div className="maine-div">
                <div className="container-fluid box-wrapper difficult">
                    <div className="page-header pb-5">
                        <div className="box-wrapper mx-auto text-center position-relative">
                            <a href="#" onClick={goBack} state={location?.state} className="page-header-back"><img src="/image/back.png" className='arrow' alt="Avatar" /></a>
                            <span className="modal-level-title levels-title">{location?.state?.name}</span>
                        </div>
                    </div>
                    <div className="quiz-thumbnail">
                        <img src={location?.state?.image} alt="Quiz" />

                    </div>
                    <div className="home-profile">
                        <div className="row gx-1">
                            <div className="col-12">
                                <h3 className="section-title2 mb-3">{language==3?t('15')+" "+location?.state?.name:location?.state?.name+" "+t('15')}</h3>
                            </div>
                            <div className="col-12 quiz-info-meta-level">
                                <span className="quiz-info-meta-circle-img"><img src="/image/Group 19.png" alt="Quiz" /></span>
                                <span className='title-gap'>10 {t('16')}</span>
                            </div>


                        </div>
                        <div className="quiz-info-content">
                            <h4 className="quiz-info-content-title">{t('18')}</h4>
                            <p>{location?.state?.description}</p>
                        </div>
                        <h3 className="choose-title mb-3">{t('21')}</h3>
                        <div className='pb-2'>

                            <div className={`row gx-0 beginner-tab d-flex align-items-baseline ${quizLevel.id == '1' ? 'active' : ''}`} onClick={() => handleQuizClick(location?.state, levels[0])}>
                                <div className="col-7 text-start">
                                    <div className="d-flex align-items-baseline">
                                        <div className="avatar2">
                                            <img src="/image/Beginner.png" alt="Avatar" />
                                        </div>
                                        <div className="flex-grow-1 ms-2">
                                            <div className="home-profile-name">{t('22')}</div>
                                            {/* <div className="home-profile-status">Guest</div> */}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-5 text-end">
                                    <div className="h-100 d-flex align-items-center justify-content-end">
                                        <div className="home-profile-points">
                                            <span className='points-text'> {levels[0].points} {t('17')}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className='pb-2'>

                            <div className={`row gx-0 intermediate-tab d-flex align-items-baseline ${quizLevel.id == '2' ? 'active' : ''}`} onClick={() => handleQuizClick(location?.state, levels[1])}>
                                <div className="col-7 text-start">
                                    <div className="d-flex align-items-baseline">
                                        <div className="avatar2">
                                            <img src="/image/Intermediate.png" alt="Avatar" />
                                        </div>
                                        <div className="flex-grow-1 ms-2">
                                            <div className="home-profile-name">{t('23')}</div>
                                            {/* <div className="home-profile-status">Guest</div> */}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-5 text-end">
                                    <div className="h-100 d-flex align-items-center justify-content-end">
                                        <div className="home-profile-points">
                                            <span className='points-text'> {levels[1].points} {t('17')}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div>

                            <div className={`row gx-0 advance-tab d-flex align-items-baseline ${quizLevel.id == '3' ? 'active' : ''}`} onClick={() => handleQuizClick(location?.state, levels[2])}>
                                <div className="col-7 text-start">
                                    <div className="d-flex align-items-baseline">
                                        <div className="avatar2">
                                            <img src="/image/Advance.png" alt="Avatar" />
                                        </div>
                                        <div className="flex-grow-1 ms-2">
                                            <div className="home-profile-name">{t('24')}</div>
                                            {/* <div className="home-profile-status">Guest</div> */}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-5 text-end">
                                    <div className="h-100 d-flex align-items-center justify-content-end">
                                        <div className="home-profile-points">
                                            <span className='points-text'> {levels[2].points} {t('17')}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                           {/* <NavLink
                                to="/finding"
                                className="btn btn-lg button-primary w-100"
                                state={{ qid: location?.state, lavel: quizLevel }}
                            >
                                {t('19')}
                            </NavLink> */}                           

                            {/* <NavLink
                                to="/play-solo"
                                className="btn btn-lg button-primary w-100"
                                state={{ qid: location?.state, level: quizLevel }}
                                style={{ marginTop: "6px" }}
                            >
                                {t("108")}
                            </NavLink> */}                              
                                <button
                                    onClick={handlePlaySolo}
                                    className={`btn btn-lg button-primary w-100 ${loading && "disabled"}`}
                                    style={{ marginTop: "6px" }}
                                    disabled={loading}
                                >
                                    {t("135")}
                                </button>

                                <button
                                onClick={handlePlay}
                                className={`btn btn-lg button-primary w-100 ${loading && "disabled"}`}
                                style={{ marginTop: "6px" }}
                                disabled={loading}
                                >
                                {t("136")}
                               </button>
                        </div>

                    </div>
                </div>
            </div>
            {popup && <PopupSub subStatus={subStatus} redirectTo={redirectTo} handleTopup={handleTopup} />}
             {popupLoader && <Popup />}
        </div>
        
    )
}

export default Screen3